import Vue from 'vue';
import moment from 'moment';

// Formato unico de fecha para toda la aplicacion: dia/mes/ano.
export const DATE_FORMAT = 'DD/MM/YYYY';

// Formatos de entrada admitidos. Se parsean en modo estricto para que moment no
// intente adivinar una fecha a partir de cadenas que no lo son.
const INPUT_FORMATS = [
	'YYYY-MM-DD',
	'YYYY-MM-DD HH:mm:ss',
	'DD/MM/YYYY',
	'DD/MM/YYYY HH:mm:ss',
	'DD-MM-YYYY',
	moment.ISO_8601,
];

// Cualquier cadena que empiece por una fecha ISO (2026-07-30, con o sin hora).
const ISO_PREFIX = /^\d{4}-\d{2}-\d{2}/;

/**
 * Devuelve una fecha en formato dd/mm/aaaa.
 *
 * Admite las fechas tal y como las envia la API (2026-07-30 o el datetime ISO
 * completo de Laravel), objetos Date y fechas ya formateadas como dd/mm/aaaa,
 * que se devuelven igual.
 *
 * Si el valor es nulo, vacio o no es una fecha reconocible devuelve cadena
 * vacia: nunca "Invalid date" ni "01/01/1970".
 */
export function formatDate(value) {
	if (value === null || value === undefined || value === '') {
		return '';
	}

	let date;

	if (value instanceof Date || moment.isMoment(value)) {
		date = moment(value);
	} else {
		const raw = String(value).trim();

		if (raw === '') {
			return '';
		}

		date = moment(raw, INPUT_FORMATS, true);

		// Laravel puede serializar los datetime con microsegundos o con zona
		// horaria; si el modo estricto no lo reconoce pero la cadena empieza por
		// una fecha ISO, se deja que moment la interprete.
		if (!date.isValid() && ISO_PREFIX.test(raw)) {
			date = moment(raw);
		}
	}

	return date.isValid() ? date.format(DATE_FORMAT) : '';
}

/**
 * Misma fecha que formatDate pero apta para un nombre de fichero: la barra no
 * se puede usar porque es separador de rutas y el navegador la sustituye.
 */
export function formatDateForFilename(value) {
	return formatDate(value).replace(/\//g, '-');
}

Vue.filter('fecha', formatDate);

// Disponible tambien desde el script de los componentes (formatters de b-table,
// nombres de fichero, etc.) para que exista un unico formateador.
Vue.prototype.$formatDate = formatDate;
